'use client';
import { useMediaQuery } from 'react-responsive';
import HeaderVariety from './header-variety';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';

const TwoThirdsDescription = ({ firstParagraph, secondParagraph, linkObj }) => {
  return (
    <div className="col-12 col-md-8">
      <div className="row">
        <div className="col-12 col-lg-6">
          <p>{firstParagraph}</p>
        </div>
        <div className="col-12 col-lg-6">
          <p>{secondParagraph}</p>
          {linkObj && (
            <a rel={getRel(linkObj)} href={linkObj.href}>
              <div className="tw-underline tw-font-bold">{linkObj.text}</div>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

const TwoThirdsTitle = ({ title, headerVariation }) => {
  return (
    <div className="col-12 col-md-4 px-lg-4">
      <HeaderVariety defaultVariation="h2" headerVariation={headerVariation} classNames="tw-mb-6">
        {' '}
        {title}{' '}
      </HeaderVariety>
    </div>
  );
};

const TwoThirdsText = (props) => {
  const { title, firstParagraph, secondParagraph, splitPosition, link, headerVariation } = props;
  const linkObj = link && Array.isArray(link) && link[0] ? buildLinkObj(link[0]) : null;
  const isMediumOrSmaller = useMediaQuery({ query: '(max-width: 767px' });
  return (
    <div className="jumbotron rotating-background d-flex justify-content-center mb-0">
      <div className="container">
        {isMediumOrSmaller || splitPosition === 'Title-left_Description-right' ? (
          <div className="row">
            <TwoThirdsTitle title={title} headerVariation={headerVariation?.headerVariation} />
            <TwoThirdsDescription
              firstParagraph={firstParagraph}
              secondParagraph={secondParagraph}
              linkObj={linkObj}
            />
          </div>
        ) : (
          <div className="row">
            <TwoThirdsDescription
              firstParagraph={firstParagraph}
              secondParagraph={secondParagraph}
              linkObj={linkObj}
            />
            <TwoThirdsTitle title={title} headerVariation={headerVariation?.headerVariation} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TwoThirdsText;
